import { render, staticRenderFns } from "./DetailsCoupon.vue?vue&type=template&id=7632a4da&scoped=true"
import script from "./DetailsCoupon.vue?vue&type=script&lang=js"
export * from "./DetailsCoupon.vue?vue&type=script&lang=js"
import style0 from "./DetailsCoupon.vue?vue&type=style&index=0&id=7632a4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7632a4da",
  null
  
)

export default component.exports